import Vue from 'vue'

export default {
    resetStateMutation(state) {
        Vue.set(state, "gridIsOpen", true);
        Vue.set(state, "formIsOpen", false);
        Vue.set(state, "prepaymentInvoiceFormIsOpen", false);
    },
    setFormOpen(state) {
        state.formIsOpen = true;
        state.gridIsOpen = false;
    },
    setFormClose(state) {
        state.formIsOpen = false;
        state.gridIsOpen = true;
    },
    setPrepaymentInvoiceFormOpen(state) {
        state.prepaymentInvoiceFormIsOpen = true;
        state.gridIsOpen = false;
    },
    setPrepaymentInvoiceFormClose(state) {
        state.prepaymentInvoiceFormIsOpen = false;
        state.gridIsOpen = true;
    }
}
